export default __webpack_public_path__ + "static/media/componentes-para-suspensao-534x444.f8e0ee68.jpg";